import { render } from "./9.vue?vue&type=template&id=77bc0a7a"
import script from "./9.vue?vue&type=script&lang=js"
export * from "./9.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__